/** Tiny WebAudio blips — no assets, degen-arcade style. */

let ctx: AudioContext | null = null;
let muted = false;

export function setMuted(m: boolean) {
  muted = m;
}

export function isMuted() {
  return muted;
}

function play(freq: number, duration: number, type: OscillatorType = "square", gain = 0.04) {
  if (muted) return;
  try {
    ctx = ctx ?? new AudioContext();
    if (ctx.state === "suspended") void ctx.resume();
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = type;
    osc.frequency.value = freq;
    g.gain.setValueAtTime(gain, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + duration);
    osc.connect(g).connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + duration);
  } catch {
    // audio unavailable
  }
}

export function chipSound() {
  play(660, 0.07);
}

export function spinSound() {
  play(220, 0.25, "sawtooth", 0.03);
}

export function winSound() {
  play(523, 0.12);
  setTimeout(() => play(659, 0.12), 110);
  setTimeout(() => play(784, 0.22), 220);
}

export function loseSound() {
  play(196, 0.2, "triangle", 0.05);
}
